export const TECH_RADAR_SCHEMA_VERSION = 1;

export const RADAR_ID_PATTERN = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

export const TECH_RADAR_INDEX_KEY = 'index.json';

export function radarDocumentKey(radarId: string): string {
  return `radars/${radarId}.json`;
}

export const RADAR_DEFINITION_FILENAME = '_index.yaml';

export const MAX_TITLE_LENGTH = 120;

export const MAX_DESCRIPTION_LENGTH = 4000;

export const MAX_ENTRIES_PER_RADAR = 500;

export const MAX_ENTRY_FILE_BYTES = 65536;
